import analyticsSettingsAPI, { AnalyticsSettingsRequest, AnalyticsSettingsResponse } from '@api/analyticsSettings'
import { makeLoader } from '@lib/loader'

export const useAnalyticsSettings = makeLoader<AnalyticsSettingsRequest, AnalyticsSettingsResponse>({
  key: 'analyticsSettings',
  loader: async params => await analyticsSettingsAPI.load(params),
  staleTime: Infinity,
})
